import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Phone, Mail, MapPin, Send, HelpCircle, Users, Star, Shield } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';

const companyInfo = {
  phone: '+971 56 913 0707',
  email: 'support@registantours.com'
};

const SiteFooter = ({ scrollToSection }) => {
  const navigate = useNavigate();
  const { t } = useLanguage();

  const handleScrollOrNav = (section) => {
    if (scrollToSection) {
      scrollToSection(section);
    } else {
      navigate('/#' + section);
    }
  };

  return (
    <footer id="contact" className="site-footer">
      <div className="footer-content">
        <div className="footer-left">
          <div className="footer-brand">
            <h2>Registan Tourism</h2>
            <p className="footer-tagline">{t('yourTrustedPartner')}</p>
          </div>
          <div className="footer-contact-info">
            <a href={`tel:${companyInfo.phone}`} className="footer-contact-item">
              <Phone size={18} />
              <span>{companyInfo.phone}</span>
            </a>
            <a href={`mailto:${companyInfo.email}`} className="footer-contact-item">
              <Mail size={18} />
              <span>{companyInfo.email}</span>
            </a>
            <div className="footer-contact-item">
              <MapPin size={18} />
              <span>Dubai, United Arab Emirates</span>
            </div>
          </div>
          <div className="footer-buttons-row">
            <a 
              href="https://t.me/changeVISAoman" 
              target="_blank" 
              rel="noopener noreferrer"
              className="footer-telegram-btn"
            >
              <Send size={18} />
              {t('joinTelegram')}
            </a>
            <button 
              onClick={() => navigate('/faq')}
              className="footer-faq-btn"
              data-testid="faq-btn"
            >
              <HelpCircle size={18} />
              {t('faq') || 'FAQ'}
            </button>
            <button 
              onClick={() => navigate('/team')}
              className="footer-nav-btn"
              data-testid="footer-team-btn"
            >
              <Users size={18} />
              {t('team') || 'Team'}
            </button>
            <button 
              onClick={() => handleScrollOrNav('reviews')}
              className="footer-nav-btn"
              data-testid="footer-reviews-btn"
            >
              <Star size={18} />
              {t('reviews') || 'Reviews'}
            </button>
          </div>
        </div>
        
        <div className="footer-right">
          <div className="footer-good-to-know">
            <h3>{t('goodToKnow')}</h3>
            <div className="policy-badge">{t('bookingPolicy')}</div>
            <p>{t('bookingPolicyText')}</p>
          </div>

          {/* Privacy link box (added per user request) */}
          <Link to="/privacy" className="footer-privacy-box" data-testid="footer-privacy-link">
            <Shield size={14} />
            <span>{t('privacyPolicy') || 'Privacy Policy'}</span>
          </Link>
        </div>
      </div>
      
      <div className="footer-bottom">
        <p>&copy; {new Date().getFullYear()} Registan Tourism. {t('allRightsReserved')}.</p>
      </div>
    </footer>
  );
};

export default SiteFooter;
